import React from 'react';
import { QuestionItem } from '../components/QuestionItem';
import { NavigationLink } from '../components/NavigationLink';
import { FooterSection } from '../components/FooterSection';
import { FaqFormDataInterface } from '@src/apps/ContentEditor/Faq/FaqForm/types';
import { FaqDrawerConstants } from '@src/apps/constants/faq-drawer';

interface CategoryQuestionsViewProps {
  faqItems: FaqFormDataInterface[];
  expandedQuestions: number[];
  selectedCategory: string;
  onToggleQuestion: (index: number) => void;
  onAllCategoriesClick: () => void;
  onMostCommonQuestionsClick: () => void;
  onContactUs?: () => void;
}

export const CategoryQuestionsView: React.FC<CategoryQuestionsViewProps> = ({
  faqItems,
  expandedQuestions,
  selectedCategory,
  onToggleQuestion,
  onAllCategoriesClick,
  onMostCommonQuestionsClick,
  onContactUs
}) => {
  return (
    <>
      <div className="main-title">{selectedCategory} Questions</div>

      <div className="questions-list">
        {faqItems.map((item, index) => (
          <QuestionItem
            key={index}
            item={item}
            isExpanded={expandedQuestions.includes(index)}
            onToggle={() => onToggleQuestion(index)}
          />
        ))}
      </div>

      <div className="bottom-section-category">
        <NavigationLink
          text={FaqDrawerConstants.allCategories}
          onClick={onAllCategoriesClick}
          className="all-categories-link"
        />

        {/* <NavigationLink
          text={FaqDrawerConstants.mostCommonQuestions}
          onClick={onMostCommonQuestionsClick}
          className="common-questions-link"
        /> */}

        {/* <FooterSection onContactUs={onContactUs} /> */}
      </div>
    </>
  );
};
